import { fetchAddFormPublishTerms, IMappers } from '../../../repositories/billing-tariffs/v2/add-form/publish-terms';
import { THeaders } from '../../../types/request';
import { mapResponse200 } from './utils';
import { ILoadPublishTermsParams, ILoadPublishTermsSuccess, TLoadPublishTermsResult } from '../types';
import { DEFAULT_RESULT } from '../constants';

export async function getPublishTermsV2(params: ILoadPublishTermsParams): Promise<TLoadPublishTermsResult> {
  const { httpApi, parameters, logger } = params;

  const headers: THeaders = [['Content-Type', 'application/json']];

  const config = {
    requestConfig: { headers },
  };

  const mappers: IMappers<ILoadPublishTermsSuccess> = {
    200: mapResponse200,
  };

  try {
    const response = await fetchAddFormPublishTerms({
      httpApi,
      parameters,
      config,
      mappers,
    });

    return response as ILoadPublishTermsSuccess;
  } catch (e) {
    logger.error(e, {
      description: 'Запрос /v2/add-form/publish-terms/',
      degradation: 'Пользователь не увидит список услуг',
      parameters: JSON.stringify(parameters),
    });

    return DEFAULT_RESULT;
  }
}
